import { render, staticRenderFns } from "./AsyncCombobox.vue?vue&type=template&id=ffb5c2ce"
import script from "./AsyncCombobox.vue?vue&type=script&lang=js"
export * from "./AsyncCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports